import { useState } from 'react';
import { useMountEffect } from './use-mount-effect';

async function load() {
  Object.assign(window, {
    esmsInitOptions: {
      // Enable Shim Mode
      shimMode: true,
      // Permit overrides to import maps
      mapOverrides: true,
    },
  });

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  await import('es-module-shims');
}

export function useLoadShims() {
  const [loaded, setLoaded] = useState(false);

  useMountEffect(() => {
    load().then(() => setLoaded(true));
  });

  return loaded;
}
